angular.module('app.filters').filter('audioPacketFormat', () =>
    function(audio) {
        if ((audio.dsd == null) && (audio.hbr == null) && (audio.multi_channel == null) && (audio.pcm == null)) { return ''; }
        if (audio.dsd) {
            return 'DSD';
        } else if (audio.hbr) {
            return 'HBR';
        } else if (audio.multi_channel) {
            return 'Multi-channel';
        } else if (audio.pcm) {
            return 'PCM';
        } else { return '(none)'; }
    }
);


// WEBPACK FOOTER //
// ./filters/audio_packet_format.js